/** axios封装 **/
import axios from "axios";
import { axiosConfig } from "./axiosConfig";
import { Message } from "element-ui";
import { CookieKeys, Cookies } from "./cookieKey";
import Qs from "qs";
import { config } from "./config";
import LibMsgBox from "../../packages/components/LibMsgBox";
import { logOutOfLogin } from "./common";
import { renderCaptcha } from "./captcha";

// 登出提醒当前是否已显示
let isLogoutToastOnShow = false;
async function handleSuccessResponse(res, options) {
  if (res.status === axiosConfig.HTTP_CODE.SUCCESS) {
    /** 判断业务code **/
    const code = parseInt(res.data.code);
    switch (code) {
      /** code 为 200 **/
      case axiosConfig.STATUS_CODE.SUCCESS:
        // x-auth-token从响应头取值，注入cookie
        if (res.headers["x-auth-token"] && options.setToken)
          Cookies.set(CookieKeys.xAuthToken, res.headers["x-auth-token"], { domain: ".qianlima.com" });
        return Promise.resolve(res.data);
      /** code 为 503 **/
      case axiosConfig.STATUS_CODE.SERVER_ERR:
        Message.error(`网络错误，请稍后重试[SERVER_ERR ${code}]`);
        return Promise.reject(res.data);
      default:
        return Promise.reject(res.data);
    }
  } else {
    return Promise.reject(res.data);
  }
}

async function handleErrorResponse(response, options) {
  const status = response && response.status;
  const data = (response && response.data) || {};
  switch (status) {
    case config.HTTP_CODE.UNAUTHORIZED:
      /** 401 **/
      if (isLogoutToastOnShow) return;
      isLogoutToastOnShow = true;
      LibMsgBox({
        title: "提示",
        message: "登录状态超时，请重新登录!",
        type: "error",
        showCancelButton: false,
      }).then(() => {
        isLogoutToastOnShow = false;
        logOutOfLogin();
      });
      return Promise.reject(data);
    case config.HTTP_CODE.ACCESS_CAPTCHA_PERMISSION_429:
      Cookies.remove(CookieKeys.accessCaptchaPermission, { domain: ".qianlima.com" });
      console.warn("headers[Access-Captcha-Permission] is expired or missing, 需要执行滑块安全验证");
      const res = await renderCaptcha({ withCredentials: false });
      console.log(res);
      const { captchaVerification } = res;
      Cookies.set(CookieKeys.accessCaptchaPermission, captchaVerification || "", { domain: ".qianlima.com" });
      return omniAxios(options);
    default: // canceler
      /** 不满足所有case时，直接返回response本身 **/
      if (response.message && response.message.includes("Axios Canceler")) {
        console.warn(response.message);
        response = {
          ...response,
          status: config.STATUS_CODE.REQUEST_CANCEL,
        };
      }
      return Promise.reject(response);
  }
}

function getHeaders(isFormData) {
  return {
    "X-Auth-Token": Cookies.get(CookieKeys.xAuthToken) || "None",
    "Content-Type": isFormData ? "application/x-www-form-urlencoded" : "application/json",
    "Access-Captcha-Permission": Cookies.get(CookieKeys.accessCaptchaPermission) || "None",
  };
}
/**
 * Axios二次封装
 * @param url 请求路径
 * @param method 请求方法
 * @param params 请求参数
 * @param isFormData 入参是否为form表单
 * @param withCredentials 是否携带身份认证
 * @param timeout 超时时间，默认无超时时间，毫秒
 * @param isTwoPointZeroInterfaceApi 是否是2.0接口
 * @param isOnePointZeroSearchInterfaceApi 是否是1.0搜索接口
 * @param useDevServerProxy 开发阶段是否使用反向代理
 * @param header 特殊接口需要单独添加的header信息
 * @param isTracker 是否为埋点接口
 * @returns {Promise<* | undefined>}
 */
export function omniAxios(options) {
  const {
    url,
    method = "get",
    params = {},
    withCredentials = true,
    timeout = 0,
    isTwoPointZeroInterfaceApi = false,
    isFormData = false,
    useDevServerProxy = false,
    header = {},
    isOnePointZeroSearchInterfaceApi = false,
    isTracker = false,
    isOnePointZeroWWWInterfaceApi = false,
    setToken = true,
  } = options;
  let headers = header;
  /** 1.0接口 **/
  let baseURL = process.env[`VUE_APP_API_1.0`];
  if (process.env.NODE_ENV === "development") {
    baseURL = "/proxyApi1.0";
  }
  if (isTwoPointZeroInterfaceApi) {
    /** 2.0接口 **/
    //自定义header需单独处理2.0接口，因为1.0接口携带自定义header就有问题，已经同步后端杨威
    baseURL = process.env["VUE_APP_API_2.0"];
    headers = Object.assign(headers, getHeaders(isFormData));

    if (process.env.NODE_ENV === "development" && useDevServerProxy) {
      baseURL = "/proxyApi2.0";
    }
  } else if (isTracker) {
    /** 埋点接口 **/
    if (process.env.NODE_ENV === "development" && useDevServerProxy) {
      baseURL = "/proxyApiTrack";
    } else {
      baseURL = process.env[`VUE_APP_API_TRACK`];
    }
  } else if (isOnePointZeroSearchInterfaceApi) {
    /** 1.0搜索接口 **/
    baseURL = process.env["VUE_APP_API_1.0_SEARCH"];
  }else if(isOnePointZeroWWWInterfaceApi){
     if (process.env.NODE_ENV === "development" && useDevServerProxy) {
      baseURL = "/proxyApiw";
    } else {
      baseURL = process.env["VUE_APP_API_1.0_WWW"];
    }
    
  }

  const axiosOptions = {
    baseURL,
    url,
    method,
    headers,
    timeout,
    withCredentials,
  };
  switch (method.toLowerCase()) {
    case "get":
      axiosOptions.params = params;
      break;
    case "post":
      axiosOptions.data = isFormData ? Qs.stringify(params) : params;
      break;
  }
  // 确保请求携带cookie
  // axios.defaults.withCredentials = withCredentials;
  return axios(axiosOptions)
    .then((res) => {
      return handleSuccessResponse(res,options);
    })
    .catch((e) => {
      return handleErrorResponse(e.response || e, options);
    });
}
